import React from 'react';
import { Button } from 'semantic-ui-react'

import SemanticUiModal from '../../components/modal';
import { getText } from '../../helpers';

function UnarchiveActions(props) {
  return (
    <div>
      <Button positive fluid size='medium' className="unarchive-control-button" onClick={props.unarchiveLibraryControl}>
        {getText("Unarchive")}
      </Button>
    </div>
  )
}

export default function ConfirmUnarchiveLibraryControl(props) {
  const modalOptions = { className: "confirm-unarchive-control", size: "tiny" }
  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={getText("Confirm Unarchive")}
      content={getText("Are you sure you want to unarchive this library control?")}
      actions={<UnarchiveActions unarchiveLibraryControl={props.unarchiveLibraryControl}/>}
      closeModal={props.hideConfirmUnarchiveControl}
    />
  )
}



// WEBPACK FOOTER //
// ./src/views/control_library/confirm_unarchive_library_control.js